import produce from 'immer'
import {
  useScimPersonalAccessTokenDeleteMutation,
  ScimPersonalAccessTokenDeleteMutationVariables,
  ScimPersonalAccessTokenDeleteMutation,
  ExecutionResult,
  MutationResult,
} from '@sketch/gql-types'
import * as scimTokensCache from './scimTokensCache'

interface UseDeleteScimPersonalAccessTokenProps {
  onCompleted: (
    data: ScimPersonalAccessTokenDeleteMutation['scimPersonalAccessTokenDelete']
  ) => void
}

type WrappedMutation = (
  variables: ScimPersonalAccessTokenDeleteMutationVariables
) => Promise<ExecutionResult<ScimPersonalAccessTokenDeleteMutation>>

export const useDeleteScimPersonalAccessToken = (
  props: UseDeleteScimPersonalAccessTokenProps
): [WrappedMutation, MutationResult<ScimPersonalAccessTokenDeleteMutation>] => {
  const { onCompleted } = props
  const [mutation, result] = useScimPersonalAccessTokenDeleteMutation({
    onError: 'show-toast',
    onCompleted: data => onCompleted(data.scimPersonalAccessTokenDelete),
  })

  const wrappedMutation: WrappedMutation = async variables => {
    return await mutation({
      variables,
      update: (cache, { data, errors }) => {
        if (!data || (errors && errors.length > 0)) return

        const me = scimTokensCache.get(cache)
        if (!me) return

        const identifierToDelete = data.scimPersonalAccessTokenDelete.identifier

        const updatedMe = produce(me, user => {
          user.scimPersonalAccessTokens = user.scimPersonalAccessTokens.filter(
            token => token.identifier !== identifierToDelete
          )
        })

        scimTokensCache.set(cache, updatedMe)
      },
    })
  }

  return [wrappedMutation, result]
}
